// extracted by mini-css-extract-plugin
export var modal = "_ds-0";